export default __webpack_public_path__ + "static/media/photo3.d2449eb5.jpg";